<template>
    <div>
        <div class="d-flex page-starter flex-md-row flex-column justify-content-start justify-content-md-center w-100">
            <div class="open-games justify-content-center d-flex">
                <div class="lottery d-flex justify-content-center">
                    <img class="eggpot-image-game-enterance-logo" src="../assets/images/eggpot.png" alt="">
                    <img class="eggpot-image-game-enterance" src="../assets/images/eggpot-game-enterance.webp" alt="">
                    <router-link :to="{name: 'lottery'}" class="play-button">
                        <img src="../assets/images/eggpot-play.png" alt="">
                    </router-link>
                </div>
            </div>
            <locked-games :totalLockedGame="4"></locked-games>
        </div>
        <div class="mx-4 d-flex justify-content-center">
            <div class="d-none d-md-flex eggs-minting-bar position-relative" style="height:69px ; border: 4px solid white ; flex-shrink: 0">
                <div style="background: #24bf00 ; height: 100%" :style="'width :' + choosenWidth + '%'"></div>
                <div class="gen-zero d-flex justify-content-center align-items-center">
                    <span>gen 0</span>
                </div>
                <div class="gen-one d-flex justify-content-center align-items-center">
                    <span>7k $EGGS</span>
                </div>
                <div class="gen-two d-flex justify-content-center align-items-center">
                    <span>14k $EGGS</span>
                </div>
                <div class="gen-three d-flex justify-content-center align-items-center">
                    <span>28k $EGGS</span>
                </div>
                <div class="gen-four d-flex justify-content-center align-items-center">
                    <span>56k $EGGS</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import LockedGames from '../components/LockedGames.vue'
export default {
    components: { LockedGames },
    name:'games',
    data(){
        return{
            choosenWidth: '45'
        }
    }
}
</script>
<style>
.page-starter{
    padding-top: 60px;
}
.lottery{
    background-image: url('../assets/images/opened-game-background.webp');
    background-size: 380px 698px;
    width: 380px;
    height: 698px;
    position: relative;
}
.eggpot-image-game-enterance{
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    margin-top: -35px;
}
.eggpot-image-game-enterance-logo{
    width: 268px;
    height: 52px;
    margin-top: 70px;
}
.eggs-minting-bar{
    width: 100%;
}
.gen-zero{
    position: absolute;
    left: 0;
    width: 20%;
    height: 100%;
    font-size: 67px;
    text-align: center;
    color: white;
    border-right: 4px solid white;
}
.gen-zero span , .gen-one span, .gen-two span, .gen-three span, .gen-four span{
    height: 69px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.gen-one{
    position: absolute;
    left: 20%;
    width: 20%;
    height: 100%;
    font-size: 67px;
    color: white;
    line-height: 3rem;
    border-right: 4px solid white;
}
.gen-two{
    position: absolute;
    left: 40%;
    width: 20%;
    height: 100%;
    font-size: 67px;
    line-height: 3rem;
    color: white;
    border-right: 4px solid white;
}
.gen-three{
    position: absolute;
    left: 60%;
    width: 20%;
    height: 100%;
    font-size: 67px;
    line-height: 3rem;
    color: white;
    border-right: 4px solid white;
}
.gen-four{
    position: absolute;
    left: 80%;
    width: 20%;
    height: 100%;
    font-size: 67px;
    line-height: 3rem;
    color: white;
}

.play-button{
    position: absolute;
    bottom: 20%;
    width: 247px;
    height: 71px;
    background-color: #0a0f1e;
    border-radius: 33px;
    border: solid 4.4px #ffe371;
    text-align: center;
}
.play-button img{
    margin-top: 5px;
}
@media (max-width:1600px) {
    .gen-zero , .gen-two , .gen-three , .gen-four , .gen-one{
        font-size: 50px;
    }
    .lottery {
        background-size: 300px 490px;
        width: 300px;
        height: 490px;
        margin: 27px 21px;
    }
    .eggpot-image-game-enterance-logo{
        width: 178px;
        height: 35px;
        margin-top: 50px;
    }
    .eggpot-image-game-enterance{
        width: 216px;
        height: 202px;
    }
    .play-button{
        width: 164px;
        height: 47px;
    }
    .play-button img{
        width: 124px;
        height: 33px;
        margin-top: 5px;
    }
}
@media (max-width:1250px) {
    .gen-zero , .gen-two , .gen-three , .gen-four , .gen-one{
        font-size: 40px;
    }
    .lottery {
        background-size: 190px 310px;
        width: 195px;
        height: 310px;
        margin: 27px 10px;
    }
    .eggpot-image-game-enterance-logo{
        width: 120px;
        margin-top: 20px;
    }
    .eggpot-image-game-enterance{
        width: 150px;
        height: 140px;
        margin-top: -20px;
    }
    .play-button{
        width: 140px;
        height: 35px;
    }
    .play-button img{
        width: 90px;
        height: 20px;
        margin-top: -3px;
    }
}
@media (max-width:780px) {
    .page-starter{
        padding: 0;
    }
    .lottery {
        background-size: 300px 490px;
        width: 300px;
        height: 490px;
        margin: 27px 21px;
    }
    .eggpot-image-game-enterance-logo{
        width: 178px;
        height: 35px;
        margin-top: 50px;
    }
    .eggpot-image-game-enterance{
        width: 216px;
        height: 202px;
    }
    .play-button{
        width: 164px;
        height: 47px;
    }
    .play-button img{
        width: 124px;
        height: 33px;
        margin-top: 5px;
    }
    
}
@media (max-width:410px) {
    
    
    
    
}
</style>